import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaderResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { AlertController } from "@ionic/angular";
import { BehaviorSubject, catchError, firstValueFrom, from, retry, switchMap, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { DataService } from "./data.service";
import { Router } from "@angular/router";
import { StorageService } from "./storage.service";
import AppConstants from "../constants/app.constants";
import { TranslationService } from "./translation.service";
import { TranslateService } from "@ngx-translate/core";
import * as CryptoJS from "crypto-js";
import { TimezoneService } from "./timezone.service";
declare var CryptoJSAesJson: any;

@Injectable({
  providedIn: "root",
})
export class ProfileService {
  auth_token: any;
  rw_token: any;
  lang: any;
  deviceInfo: any;
  x_refresh_token: any;

  public userDataSubject = new BehaviorSubject<any>(null);
  userData$ = this.userDataSubject.asObservable();
  apiURL: string = "";


  private get translationService(): TranslationService {
    return this.injector.get(TranslationService);
  }
  private get translateService(): TranslateService {
    return this.injector.get(TranslateService);
  }
  constructor(
    private alertCtrl: AlertController,
    private dataService: DataService,
    private router: Router,
    public http: HttpClient,
    public storageService: StorageService,
    private injector: Injector,
    private timezoneService: TimezoneService,
  ) {
    this.init();
    this.apiURL = environment.apiUrl;
  }

  async init() {
    this.lang = this.storageService.getItem(AppConstants.SELECTED_LANGUAGE);
  }


  private async buildHeaders(
    customHeaders: Record<string, string> = {}
  ): Promise<{ headers: HttpHeaders }> {
    const auth_token =
      (await this.storageService.getItemIonic(AppConstants.AUTH_TOKEN)) || "";
    const rw_token =
      (await this.storageService.getItemIonic(AppConstants.RW_HASH_TOKEN)) ||
      "";
    const x_refresh_token =
      (await this.storageService.getItemIonic(AppConstants.x_refresh_token)) ||
      "";
    const timezoneOffset = this.timezoneService.timezoneName;

    return {
      headers: new HttpHeaders({
        Accept: "application/json",
        Authorization: `Bearer ${auth_token}`,
        RW_AUTH: `Bearer ${rw_token}`,
        x_refresh_token: `${x_refresh_token}`,
        timezone: timezoneOffset,
        ...customHeaders,
      }),
    };
  }

  async ensureAuthenticated() {
    const now = Date.now();
    const changePasswordStatus = await this.storageService.getItemIonic(
      AppConstants.CHANGE_PASSWORD_STATUS
    );

    try {
      const res: any = await this.getCheckUser(changePasswordStatus);

      if (res?.data?.code === 200) {
        try {
          this.storageService.setItemIonic(
          AppConstants.x_refresh_token,
          res.tokens.retter_refresh_token
        );
        this.storageService.setItemIonic(
          AppConstants.RW_HASH_TOKEN,
          res.tokens.rw_auth_token
        );
        this.storageService.setItemIonic(
          AppConstants.AUTH_TOKEN,
          res.tokens.retter_auth_token
        );

        } catch (error) {
          console.error("Error updating tokens:", error);
        }

      } else if (res?.data?.code === 403) {
        const alertNetPopup = await this.alertCtrl.create({
          message: res.data.message,
          mode: 'md',
          backdropDismiss: false,
          buttons: [
            {
              text: "Ok",
              handler: () => {
                return true;
              },
            },
          ],
        });

        await alertNetPopup.present();

        const { role } = await alertNetPopup.onDidDismiss();
        if (
          role === "cancel" ||
          role === "backdrop" ||
          role === "ok" ||
          role === undefined
        ) {
          this.deviceInfo = await this.storageService.getItemIonic(
            AppConstants.DEVICE_INFO
          );
          const payload = {
            playerId: this.deviceInfo.uuid,
            deviceType: 2,
          };
          if (this.deviceInfo.operatingSystem === "android") {
            payload.deviceType = 1;
          } else if (this.deviceInfo.operatingSystem === "ios") {
            payload.deviceType = 0;
          } else {
            payload.deviceType = 2;
          }
          // await this.httpService.patch("auth/user/logout", payload);
          this.http.patch(`${this.apiURL}auth/user/logout`, payload, await this.buildHeaders()).subscribe({
            next: (response) => {
              console.log('Logout successful:', response);
              this.logOut();
            },
            error: (error) => {
              console.error('Logout failed:', error);
              // Even if logout API fails, clear session and navigate to login
              this.logOut();
            }
          });
          
        }
      }
    } catch (error) {
      console.error("Error during ensureAuthenticated:", error);
    }
  }

  async createAuthHeader() {
    await this.ensureAuthenticated();
    return { headers: this.buildHeaders() };
  }

  async getCheckUser(changePassword: any) {
    this.deviceInfo = await this.storageService.getItemIonic(
      AppConstants.DEVICE_INFO
    );

    this.deviceInfo.player_id = this.deviceInfo.uuid;

    const payload = {
      lang: this.storageService.getItem(AppConstants.SELECTED_LANGUAGE),
      player_id: this.deviceInfo.player_id,
      change_password: changePassword,
    };

    return firstValueFrom(
      from(this.buildHeaders()).pipe(
        switchMap((options) =>
          this.http.post<any>(
            `${environment.apiUrl}user/other/getCheckUser`,
            payload,
            options
          )
        ),
        retry(1),
        catchError((error: HttpErrorResponse) => {
          if (error.error?.message === 'auth_token_expired_or_invalid') {
            void this.logOut();
          }
          return throwError(() => error);
        })
      )
    );
  }


  async logOut() {
    try {
      await this.alertCtrl.dismiss();
    } catch (e) {
    }
    this.storageService.removeItem(AppConstants.CHAT_TOKENS);
    this.dataService.destroyDB();
    await this.storageService.clearIonic();

    // (
    //   await this.translationService.getTranslation(
    //     AppConstants.DEFAULT_LANGUAGE
    //   )
    // ).subscribe((translations: any) => {
    //   this.translateService.setTranslation(
    //     AppConstants.DEFAULT_LANGUAGE,
    //     translations,
    //     true
    //   );
    //     console.log("profile service =============Loaded translations for", AppConstants.DEFAULT_LANGUAGE);

    //   this.translateService.use(AppConstants.DEFAULT_LANGUAGE);
    // });
    this.storageService.setItem(
      AppConstants.SELECTED_LANGUAGE,
      AppConstants.DEFAULT_LANGUAGE
    );
    this.router.navigateByUrl("/auth/login", { replaceUrl: true });
  }

  async authorization(status: any) {
    if (status == 0) {
      this.logOut();
    } else {
      return;
    }
  }

  decryptFileFunction(response: any) {

    const CustomFormat = {
      stringify: function (cipherParams: any) {
        const j = {
          ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64),
          iv: cipherParams.iv.toString(),
          s: cipherParams.salt.toString(),
        };
        return JSON.stringify(j);
      },
      parse: function (jsonStr: string) {
        const j = JSON.parse(jsonStr);
        const cipherParams = CryptoJS.lib.CipherParams.create({
          ciphertext: CryptoJS.enc.Base64.parse(j.ct),
          iv: CryptoJS.enc.Hex.parse(j.iv),
          salt: CryptoJS.enc.Hex.parse(j.s),
        });
        return cipherParams;
      },
    };
    let encrypted = response;
    let password = "rescuedigitalfile";
    let decrypted = CryptoJS.AES.decrypt(encrypted, password, {
      format: CustomFormat,
    }).toString(CryptoJS.enc.Utf8);
    decrypted = JSON.parse(decrypted);
    return decrypted;
  }

  decryptFileFunction1(fileUrl: string) {
    const CustomFormat = {
      stringify: function (cipherParams: any) {
        const j = {
          ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64),
          iv: cipherParams.iv.toString(),
          s: cipherParams.salt.toString(),
        };
        return JSON.stringify(j);
      },
      parse: function (jsonStr: string) {
        const j = JSON.parse(jsonStr);
        const cipherParams = CryptoJS.lib.CipherParams.create({
          ciphertext: CryptoJS.enc.Base64.parse(j.ct),
          iv: CryptoJS.enc.Hex.parse(j.iv),
          salt: CryptoJS.enc.Hex.parse(j.s),
        });
        return cipherParams;
      },
    };

    const jsonStr = fileUrl.substring(
      fileUrl.indexOf("{"),
      fileUrl.lastIndexOf("}") + 1
    );

    const password = "rescuedigitalfile";
    let decrypted = CryptoJS.AES.decrypt(jsonStr, password, {
      format: CustomFormat,
    }).toString(CryptoJS.enc.Utf8);

    try {
      return JSON.parse(decrypted);
    } catch (e) {
      return decrypted;
    }
  }
}
